// extracted by mini-css-extract-plugin
export default {"block":"Block_block__0OWPq","image":"Block_image__-cbSJ","texts":"Block_texts__dsONR","title":"Block_title__Dy3wc","article":"Block_article__dn4ns"};